import {useEffect, useState} from 'react';

// Keep the route restriction aligned with the existing mobile styles.
const SMALL_SCREEN_QUERY = '(max-width: 768px)';

export default function useSmallScreen() {
    const [isSmallScreen, setIsSmallScreen] = useState(
        () => window.matchMedia(SMALL_SCREEN_QUERY).matches
    );

    useEffect(() => {
        const mediaQuery = window.matchMedia(SMALL_SCREEN_QUERY);
        const updateScreen = () => setIsSmallScreen(mediaQuery.matches);

        if (mediaQuery.addEventListener) {
            mediaQuery.addEventListener('change', updateScreen);
        } else {
            mediaQuery.addListener(updateScreen);
        }
        updateScreen();

        return () => {
            if (mediaQuery.removeEventListener) {
                mediaQuery.removeEventListener('change', updateScreen);
            } else {
                mediaQuery.removeListener(updateScreen);
            }
        };
    }, []);

    return isSmallScreen;
}
